import React, { useState } from 'react'
import { Container, Content, Input, Label } from './styled'
interface InputLabelProps {
  title: string
  fontSize?: string
  color?: string
  htmlFor: string
}
interface SelectProps {
  bordercolor: string
  backgroundcolor: string
  outlinecolor?: string
  currentOption: string | any
  data?: { id?: string; value?: string | number }[]
  label: InputLabelProps
  onchange: (e) => void
  flex?: string
  padding?: string
  name?: string
  disabled?: boolean
}

export const Select = ({
  backgroundcolor,
  bordercolor,
  outlinecolor,
  data,
  currentOption,
  flex,
  padding,
  label,
  name,
  onchange,
  disabled = false,
}: SelectProps) => {
  // const [current, setCurrent] = useState(currentOption)

  return (
    <Container flex={flex}>
      <Label
        color={label.color}
        fontSize={label.fontSize}
        htmlFor={label.htmlFor}
      >
        {label.title}
      </Label>
      <Content
        backgroundcolor={backgroundcolor}
        bordercolor={bordercolor}
        outlinecolor={outlinecolor}
      >
        <Input
          onChange={onchange}
          value={currentOption}
          placeholder="selecionar"
          padding={padding}
          name={name}
          required
          disabled={disabled}
        >
          <option value="" selected>
            Selecionar uma opção
          </option>
          {data?.map((option) => {
            return (
              <>
                <option key={option.id} id={option.id} value={option.id}>
                  {option.value}
                </option>
              </>
            )
          })}
        </Input>
      </Content>
    </Container>
  )
}
